import React, {useEffect} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {fetchBranchById, updateBranch} from "../../store/branch-slice";
import {branchSchema} from "../../schema/branchSchema";
import {getFormData} from "../../models/branchModel";
import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import Form from "../../components/common/form/Form";
import {getValidatedLimit} from "../../components/Utility";
import {fetchRestaurantList} from "../../store/list-slice";

const BranchEdit = () => {
    const params = useParams();
    const navigator = useNavigate();
    const dispatch = useDispatch();
    const {pagination} = useSelector(state => state.branch);
    const {limit, currentPage} = getValidatedLimit(pagination);

    const {
        items,
        updateStatus,
        fetchByIdStatus,
        error
    } = useSelector(state => state.branch);
    const list = useSelector(state => state.list);


    useEffect(() => {
        dispatch(fetchBranchById(params.branchId));
        dispatch(fetchRestaurantList());
    }, [dispatch, params.branchId]);

    const branch = items.find(item => item.id === params.branchId);

    useEffect(() => {
        if (updateStatus === "success") {
            navigator(`../../?page=${currentPage}&limit=${limit}`);
        }
    }, [updateStatus, navigator, currentPage, limit]);

    const formSubmitHandler = (data) => {
        dispatch(updateBranch({...data, id: branch._id}));
    };

    const formCancelHandler = () => {
        navigator(`../../?page=${currentPage}&limit=${limit}`);
        ;
    };

    const schema = branchSchema({list});
    const initialData = getFormData(branch);

    return (
        <>
            <SubHeader title="Update Branch">
                <Button to={`../../?page=${currentPage}&limit=${limit}`}
                        className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                <div className="row">
                    <div className="col-xl-8">
                        {fetchByIdStatus === "loading" && <p>Loading...</p>}
                        {fetchByIdStatus === "failed" && <h6 className="text-danger">{error}</h6>}
                        {fetchByIdStatus === "success" &&
                            <Form
                                onFormSubmit={formSubmitHandler}
                                onFormCancel={formCancelHandler}
                                schema={schema}
                                inline={false}
                                initialData={initialData}
                                status={updateStatus}
                                error={error}
                            />
                        }
                    </div>
                </div>
            </div>
        </>
    );
};

export default BranchEdit;
